<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/5/logo.png`" :width="1.72" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/5/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand5" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn'}">
				<p class="field_1" :class="{'item_center': lang=='zh-cn'}" v-html="detail.field_1"></p>
				<p class="field_2" :class="{'item_center': lang=='zh-cn'}" :style="{ 'marginTop': lang=='zh-cn'? '0.64rem' : '0.51rem' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '0.94rem' : '1.2rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.32rem' : '1.16rem' }">
				<p class="field_1" v-html="detail.field_4"></p>
				<p :class="{'field_4': lang=='zh-cn', 'field_2': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.69rem' : '0.46rem' }" v-html="detail.field_5"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.07rem' : '1rem' }"><img :src="detail.field_6" width="100%" /></p>
			<p class="brandImg_style2" style="margin-top:1.78rem"><img :src="detail.field_7" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.97rem' : '0.91rem' }">
				<p class="field_1" v-html="detail.field_8"></p>
				<p :class="{'field_4': lang=='zh-cn', 'field_2': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.41rem' : '0.38rem' }" v-html="detail.field_9"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1rem' : '0.71rem' }"><img :src="detail.field_10" width="100%" /></p>
			<a class="brandLinkWrap gary" href="http://www.heylads.com" target="_blank">
				<p class="brandLink1">{{ $t('shoplink') }}</p>
				<p class="brandLink2">www.heylads.com</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(12)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand5.vue